import { Prompt } from "react-router-dom";
import React from "react";

export default props => (
  <Prompt
    message="ETES VOUS SUR DE VOULOIR QUITTER CETTE PAGE ? "
    when={props.warn}
  />
);
